import { AlertController } from '@reown/appkit-controllers'
import { createAppKit } from '@reown/appkit/react'

type CreateAppKitOptions = Parameters<typeof createAppKit>[0]
const PROJECT_ID_NOT_CONFIGURED_CODE = 'APKT008'

export type AppKitConnectionMode = 'discovery' | 'explicit'

/**
 * AppKit 1.8.19 requires a project id even when its remote wallet surface is disabled. Exact mode
 * deliberately leaves it empty to prevent WalletConnect initialization, so ignore only that known
 * compatibility alert while preserving every other AppKit error.
 *
 * @see https://github.com/reown-com/appkit/blob/9f025c2fae0684544117bbca755dbb39f1e9606f/packages/appkit/src/client/appkit-base-client.ts#L471-L475
 */
export function createAppKitForConnectionMode(
  options: CreateAppKitOptions,
  connectionMode: AppKitConnectionMode
) {
  if (connectionMode !== 'explicit') return createAppKit(options)

  const originalOpen = AlertController.open
  AlertController.open = (message, variant) => {
    if (message.code === PROJECT_ID_NOT_CONFIGURED_CODE && variant === 'error') return
    originalOpen.call(AlertController, message, variant)
  }

  try {
    return createAppKit(options)
  } finally {
    AlertController.open = originalOpen
  }
}
